export default "__VITE_ASSET__BjXn2Wiq__"